import { configureStore } from "@reduxjs/toolkit";
import videosReducer from "./videosSlice";
import usersReducer from "./usersSlice";
import projectsReducer from "./projectsSlice";
import appReducer from "./appSlice";
import tariffesReducer from "./tariffesSlice";

// Custom middleware for logging actions and state changes
const loggerMiddleware = (store) => (next) => (action) => {
  console.group(
    `%cAction: ${action.type}`,
    "color: #4CAF50; font-weight: bold"
  );
  console.log(
    "%cPrevious State:",
    "color: #9E9E9E; font-weight: bold",
    store.getState()
  );
  console.log("%cAction:", "color: #03A9F4; font-weight: bold", action);

  const result = next(action);

  console.log(
    "%cNext State:",
    "color: #4CAF50; font-weight: bold",
    store.getState()
  );
  console.groupEnd();

  return result;
};

export const store = configureStore({
  reducer: {
    videos: videosReducer,
    users: usersReducer,
    projects: projectsReducer,
    app: appReducer,
    tariffes: tariffesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(loggerMiddleware),
});
